import { makeQueryStrings } from "@/utilities/common";

export const apiUrl = {
  AccessToken: {
    AccessTokenGenerate: "/api/AccessToken/generate"
  },
  Customer: {
    customerSelect: (param: any) => `/api/Customer/${param.cid}/select`,
    getUsers: (param: any) => `/api/Customer/${param.cid}/users`,
    getCustomer: (param: any) => `/api/Customer/${param.cid}`,
    deleteDefault: "/api/Customer/default",
    currentCustomerAccountList: (param: any) => `/api/Customer/${param.cid}/accounts`,
  },
  AccountApiList: {
    uploadMSALInfo: "/api/User/msa/getUsers",
    createCustomer: "/api/Customer",
    getCIDList: "/api/Customer/msa/getCustomers",
    setDefaultCID: "/api/Customer/default",
    createAccount: "/api/Account",
    getAccount: (param: any) => `/api/Account/${param.aid}`,
    editAccount: (param: any) => `/api/Account/${param.aid}`,
  },
  Invitation: {
    invitation: "/api/User/invitation",
    checkInvitation: "/api/User/invitation/check",
    acceptanceInvitation: "/api/User/invitation/accept"
  },
  User: {
    getCurrentUserAccounts: (param: any) => `/api/User/${param.uid}/accounts`,
    getCurrentUser: (param: any) => `/api/User/${param.uid}`,
    acceptanceInvitation: "/api/User/invitation/acceptance"
  },
  AdCreativeForm: {
    getCampaignCenterList: (param: any) => `/api/AdCreativeForm/${param.aid}/list`,
    editCampaignCenter: (param: any) => `/api/AdCreativeForm/UpdateAdCreative/${param.accountId}/${param.creativeId}`,
    deleteCampaignCenter: (param: any) => `/api/AdCreativeForm/${param.creativeId}`,
    singleCampaignCampaignCenter: (param: any) => `/api/AdCreativeForm/${param.creativeId}`,
    createCampaign: "/api/AdCreativeForm",
    updateCampaignName: (param: any) => `/api/AdCreativeForm/${param.aid}/${param.creativeId}/${param.name}`,
    downloadUserCampaign: (param: any) => `/api/AdCreativeForm/download/${param.creativeId}`,
    deliver: (param: any) => `/api/AdCreativeForm/review/${param.creativeId}`,
    preview: (param: any) => `/api/AdCreativeForm/preview/${param.creativeId}`,
    GetValidAdCreatives: (param: any) => `/api/AdCreativeForm/GetValidAdCreatives/${param.inquiryId}/${param.endTime}/${param.channel}`,
    getTemplateList: "/api/AdCreativeTemplate/childrentemplate",
    GetInquiryOrders: (param: any) => `/api/AdCreativeForm/GetInquiryOrders/${param.aid}`,
    GetAdCreativeForm: (param:any) => `/api/AdCreativeForm/GetAdCreativeDataByAdCreativeFormId?adCreativeFormId=${param.formId}`,
    GetAdCreative: (param:any) => `/api/AdCreativeForm/GetAdCreativeDataByAdCreativeId?adCreativeId=${param.formId}`,
    grouptemplate: (param:any) => `/api/AdCreativeTemplate/grouptemplate?targetMarket=${param.targetMarket}`,
    getTemplateChild: (param:any) => `/api/AdCreativeTemplate/template/${param.PID}?inquiryId=${param.inquiryId}`,
    updateName: "/api/AdCreativeForm/updatename",
    IsReadyToCreate: (param:any) => `/api/AdCreativeForm/IsReadyToCreate/${param.aid}`,
    Warn: (param:any) => `/api/AdCreativeForm/Warn/${param.aid}/${param.inquiryId}`,
    UploadImage: (data:any) => `/api/AdCreativeForm/uploadimage/${data.aid}`,
    UploadVideo: (data:any) => `/api/AdCreativeForm/uploadvideo/${data.aid}`,
    GetExtraTemplateList: (data:any) => `/api/AdCreativeForm/ExtraTemplateList?aid=${data.aid}`,
    GetSuperBrandCardInfoList: "/api/AdCreativeForm/SuperBrandCardInfoList"
  },
  Campaign: {
    getCampaignList: (param: any) => `/api/Campaign/${param.accountid}/GetCampaignList${makeQueryStrings(param)}`,
    getUnitList: (param: any) => `/api/CampaignUnit/${param.accountid}/GetUnitList${makeQueryStrings(param)}`,
    postStartUnit: "/api/CampaignUnit/StartUnit",
    postStopUnit: "/api/CampaignUnit/StopUnit",
    postStopUnitImmediately: "/api/CampaignUnit/StopUnitImmediately",
    postSystemStartUnit: "/api/CampaignUnit/SystemStartUnit",
    postSystemStopUnit: "/api/CampaignUnit/SystemStopUnit",
    postUpdateCampaignName: "/api/Campaign/UpdateCampaignName",
    postUpdateUnitName: "/api/CampaignUnit/UpdateUnitName",
    GetValidatedCampaignList: (param: any) => `/api/Campaign/${param.aid}/GetValidatedCampaignList`,
    GetAdCreativeResult: (param:any) => `/api/Campaign/GetAdCreativeResultByFormId?formId=${param.formId}`,
    GetUnitReport: (param:any) => `/api/Report/unitmaterial${makeQueryStrings(param)}`,

  },
  Qualification: {
    getQualificationItems: (param: any) => `/api/qualification/${param.accountId}/list`,
    getMultiplableQualificationCategories: () => "/api/qualification/multipliablecategories",
    handleFile: (param: any) => `/api/Qualification/a${param.accountId}/${param.view}_${param.qId}/file_${param.fileId}`,
    getQualificationIndustry: (param: any) => `/api/Qualification/${param.accountId}/industry`,
    getQualificationDetail: (param: any) => `/api/Qualification/${param.accountId}/${param.view}/detail/${param.qId}`,
    updateMainQuailification: (param: any) => `/api/Qualification/${param.accountId}/main/${param.qId}/update`,
    updateIcpQuailification: (param: any) => `/api/Qualification/${param.accountId}/icp/${param.qId}/update`,
    updateTrademarkQuailification: (param: any) => `/api/Qualification/${param.accountId}/trademark/${param.qId}/update`,
    updateIndustryQuailification: (param: any) => `/api/Qualification/${param.accountId}/industry/${param.qId}/update`,
    addQuailification: (param: any) => `/api/Qualification/${param.accountId}/${param.view}/new`,
    updateQuailification: (param: any) => `/api/Qualification/${param.accountId}/${param.view}/${param.qId}/update`,
    deleteQualification: (param: any) => `/api/Qualification/${param.accountId}/qualification/${param.qId}/delete`,
    getNextaction: (param: any) => `/api/Qualification/${param.accountId}/nextaction`
  },
  UnitAdCreative: {
    getUnitAdCreative: "/api/UnitAdCreative/list",
    createUnitAdCreative: "/api/UnitAdCreative",
    updateUnitAdCreative: (param: any) => `/api/UnitAdCreative/${param.aid}/${param.unitCreativeId}/${param.name}`,
    editUnitAdCreative: (param: any) => `/api/UnitAdCreative/${param.unitId}/${param.unitCreativeId}/${param.startTime}/${param.endTime}`,
    deleteUnitAdCreative: (param: any) => `/api/UnitAdCreative/${param.unitCreativeId}`,
    previewUnitAdCreative: (param: any) => `/api/UnitAdCreative/preview/${param.unitCreativeId}`,
    getValidTimesForAdd: (param: any) => `/api/UnitAdCreative/GetValidTimesForAdd/${param.unitId}`,
    getValidTimesForEdit: (param: any) => `/api/UnitAdCreative/GetValidTimesForEdit/${param.unitId}/${param.unitCreativeId}`,
    reportdemo: "/api/UnitAdCreative/reportdemo",
    getCampaignList: (param: any) => `/api/Campaign/${param.accountId}/GetCampaignList`,
    UpdateName: "/api/UnitAdCreative/updatename",
    getUnitAdCreativeReport: (param:any) => `/api/report/creativematerial${makeQueryStrings(param)}`,
    getMatchedForCreativeWithUnit: (param: any) => `/api/UnitAdCreative/GetMatchedForCreativeWithUnit/${param.unitId}/${param.creativeId}`,
  },
  Ket: {
    getHistory: (param: any) => `/api/Ket/list?pageIndex=${param.pageIndex}&pageSize=${param.pageSize}`,
    getById: (param: any) => `/api/Ket/getitem/${param.id}`,
    view: (param: any) => `/api/Ket/view/${param.id}`,
    download: (param: any) => `/api/Ket/download/${param.id}`,
    delete: (param: any) => `/api/Ket/${param.id}`,
    search: "/api/Ket/search",
    estimate: "/api/Ket/estimatedtime"
  },
  Inquiry: {
    getAccountInquiryStatus: (param: any) => `/api/Inquiry/${param.aid}/status/${param.inquiryOrderType}`,
    getInquiryList: (param: any) => `/api/Inquiry/${param.aid}/list/${param.orderType}`,
    creativeInquiry: (param: any) => `/api/Inquiry/${param.accountId}/new/${param.orderType}`,
    dealInquiryList: (param: any) => `/api/Inquiry/${param.aid}/${param.inquiryId}/deal`,
    getCurrentInquiry: (param: any) => `/api/Inquiry/a${param.aid}/inquery_${param.inquiryId}`,
    getInquiryDetail: (param: any) => `/api/Inquiry/a${param.aid}/inquerydetail_${param.inquiryId}`,
    getOrderDetail: (param: any) => `/api/Inquiry/a${param.aid}/orderdetail_${param.inquiryId}`,
    getInquiryoptions: (param: any) => `/api/Inquiry/${param.aid}/inquiryformoptions/${param.orderType}`,
    editInquiry: (param: any) => `/api/Inquiry/${param.accountId}/edit/${param.inquiryOrderId}/${param.orderType}`,
    deleteCurrentInquiry: (param: any) => `/api/Inquiry/${param.aid}/${param.inquiryId}/delete`,
    abandonCurrentInquiry: (param: any) => `/api/Inquiry/${param.aid}/${param.inquiryId}/abandon?reason=${param.reason}`,
    draftInquiry: (param: any) => `/api/Inquiry/${param.accountId}/draft/${param.inquiryId}/${param.orderType}`,
    DownloadinquiryorderdetailbyCID: (params: any) => `/api/Orders/${params.customerId}/downloadinquiryorderdetailbyCID/${params.agentId}/${params.inquiryOrderId}/${params.priceVersion}`,
  },
  Report: {
    ready: (params: any) => `/api/Report/ready${makeQueryStrings(params)}`,
    dataready: (params: any) => `/api/Report/dataready${makeQueryStrings(params)}`,
    getAccountReportList: (params: any) => `/api/Report/account${makeQueryStrings(params)}`,
    getCampaignReport: (params: any) => `/api/Report/campaign${makeQueryStrings(params)}`,
    getCampaignUnitReport: (params: any) => `/api/Report/campaignunit${makeQueryStrings(params)}`,
    getUnitAdCreativeReport: (params: any) => `/api/Report/unitadcreative${makeQueryStrings(params)}`,
    getURLClickReport: (params: any) => `/api/Report/URLClick${makeQueryStrings(params)}`,
    getOrderReport: (params: any) => `/api/Report/order${makeQueryStrings(params)}`,
    getKeywordReport: (params: any) => `/api/Report/keyword${makeQueryStrings(params)}`,
    getTemplateReport: (params: any) => `/api/Report/template${makeQueryStrings(params)}`,
    getMonthlyReport: (params: any) => `/api/Bill${makeQueryStrings(params)}`,
    downloadAccountReport: (params: any) => `/api/ReportDownload/account${makeQueryStrings(params)}`,
    downloadCampaignReport: (params:any) => `/api/ReportDownload/campaign${makeQueryStrings(params)}`,
    downloadCampaignUnitReport: (params:any) => `/api/ReportDownload/campaignunit${makeQueryStrings(params)}`,
    downloadUnitAdCreativeReport: (params:any) => `/api/ReportDownload/unitadcreative${makeQueryStrings(params)}`,
    downloadURLClickReport: (params:any) => `/api/ReportDownload/urlclick${makeQueryStrings(params)}`,
    downloadOrderReport: (params:any) => `/api/ReportDownload/order${makeQueryStrings(params)}`,
    downloadKeywordReport: (params:any) => `/api/ReportDownload/keyword${makeQueryStrings(params)}`,
    downloadTemplateReport: (params:any) => `/api/ReportDownload/template${makeQueryStrings(params)}`,
    downloadMonthlyReport: (params:any) => `/api/Bill/download${makeQueryStrings(params)}`,
    extraReport: (params: any) => `/api/Report/extra${makeQueryStrings(params)}`,
    downloadExtraReport: (params: any) => `/api/ReportDownload/extra${makeQueryStrings(params)}`,
    inquiryTabControl: (params: any) => `/api/Inquiry/TabControl${makeQueryStrings(params)}`
  },
  Dashboard: {
    getCustomerReport: (params: any) => `/api/Report/panelbycid${makeQueryStrings(params)}`,
    getCustomerDetaileport: (params: any) => `/api/Report/paneldetailbycid${makeQueryStrings(params)}`,
    getAccountReport: (params: any) => `/api/Report/panelbyaid${makeQueryStrings(params)}`,
    getAccountDetaileport: (params: any) => `/api/Report/paneldetailbyaid${makeQueryStrings(params)}`,
    getInqueryData: (params:any) => `/api/home/statistics/${params.type}/${params.id}`,
    getCampaignData: "/api/Campaign/GetCampaignStatusSummary"
  },
  Feedback: {
    submitFeedback: "/api/Feedback/feedback",
    uploadFile: "/api/Feedback/uploadFile"
  },
  agencyManagement: {
    Orders: {
      getInquirylist: (params: any) => `/api/Orders/${params.cid}/inquirylist`,
      getOrderList: (params: any) => `/api/Orders/${params.cid}/orderlist`,
      getInquiryOrderDetail: (params: any) => `/api/Orders/${params.cid}/inquiryorderdetail/${params.inquiryId}`,
      getOrderDetail: (params: any) => `/api/Orders/${params.cid}/orderdetail/${params.inquiryId}`,
      OrderDeal: (params: any) => `/api/Orders/${params.customerId}/deal`,
      OrderAbandoninquiryorder: (params: any) => `/api/Orders/${params.customerId}/abandoninquiryorder/${params.inquiryOrderId}?abandonReason=${params.abandonReason}`,
      Downloadinquiryorderdetail: (params: any) => `/api/Orders/${params.customerId}/downloadinquiryorderdetail/${params.inquiryOrderId}/${params.priceVersion}`,
      DownloadinquiryorderAgency: (params: any) => `/api/Orders/${params.customerId}/downloadinquiryorderagency`,
      DownloadorderAgency: (params: any) => `/api/Orders/${params.customerId}/downloadorderagency`,
      Temporarycancellationorderids: "/api/Orders/temporarycancellationorderids",
    },
    RealBill: {
      getList: (params: any) => `/api/RealBill${makeQueryStrings(params)}`,
      download: (params: any) => `/api/RealBill/download${makeQueryStrings(params)}`,
      getGlobalList: (params: any) => `/api/RealBill/global${makeQueryStrings(params)}`,
    }
  },
  LeadGen: {
    CampaignUnitAdCreative: {
      getCampaignUnitAdCreativeList: (params: any) => `/api/LeadGenUnitAdCreative/${params.aid}/list`,
      getCampaignUnitAdCreative: (params: any) => `/api/LeadGenUnitAdCreative/${params.aid}/get`,
      createCampaignUnitAdCreative: "/api/LeadGenUnitAdCreative/create",
      updateName: (params: any) => `/api/LeadGenUnitAdCreative/${params.aid}/updatename`,
      deleteCampaignUnitAdCreative: (params: any) => `/api/LeadGenUnitAdCreative/${params.aid}/${params.unitCreativeId}`,
      reviewCampaignUnitAdCreative: (params: any) => `/api/LeadGenUnitAdCreative/${params.aid}/get?accountId=${params.aid}&creativeId=${params.unitCreativeId}`,
      downloadFileContent: (params: any) => "/api/Feedback/downloadFileContent?filePath=" + encodeURIComponent(params.filePath),
      uploadFile: (params: any) => `/api/LeadGenUnitAdCreative/${params.aid}/uploadfile`,
      deleteFile: (params: any) => `/api/LeadGenUnitAdCreative/${params.aid}/delfile?fileId=${params.fileId}`,
      getOptions: (params: any) => `/api/LeadGenUnitAdCreative/${params.aid}/creationoptions`,
      createCampaignUnitAdCreativeFrom: "/api/LeadGenUnitAdCreative/createEx"
    },
    CampaignUnit: {
      getCampaignUnitList: (params: any) => `/api/LeadGenCampaignUnit/${params.aid}/list`,
      createCampaignUnit: (params: any) => `/api/LeadGenCampaignUnit/${params.aid}`,
      getCampaignunitcreationoptions: (params: any) => `/api/LeadGenCampaignUnit/${params.aid}/creationoptions`,
      deleteCampaignUnit: (params: any) => `/api/LeadGenCampaignUnit/${params.aid}/${params.unitId}`,
      updateName: (params: any) => `/api/LeadGenCampaignUnit/${params.aid}/${params.unitId}/campaignUnitName?campaignUnitName=${encodeURIComponent(params.campaignUnitName)}`,
      preview: (params: any) => `/api/LeadGenCampaignUnit/${params.aid}/${params.adPlacementId}/adplacementpreview`,
    },
    Campaign: {
      getCampaignList: (params: any) => `/api/LeadGenCampaign/${params.aid}/list`,
      createCampaign: (params: any) => `/api/LeadGenCampaign/${params.aid}`,
      getCreationoptions: (params: any) => `/api/LeadGenCampaign/${params.aid}/creationoptions`,
      deleteCampaign: (params: any) => `/api/LeadGenCampaign/${params.aid}/${params.campaignId}`,
      updateName: (params: any) => `/api/LeadGenCampaign/${params.aid}/${params.campaignId}/campaignName?campaignName=${encodeURIComponent(params.campaignName)}`,
    },
    BillingReport: {
      getList: "/api/LeadGenBillingReport/getlist",
      downloadItem: (id: any) => `/api/LeadGenBillingReport/download/${id}`,
      getPreviewList: (id: any) => `/api/LeadGenBillingReport/getItemList/${id}`,
      getItemsDetail: (id: any) => `/api/LeadGenBillingReport/item/get/${id}`,
      editItemsDetail: (id: any) => `/api/LeadGenBillingReport/item/update/${id}`,
      submitItemDatas: (id: any) => `/api/LeadGenBillingReport/submit/${id}`,
      getBillingSummary: (id: any) => `/api/LeadGenBillingReport/getSummary/${id}`,
    },
    AccrualReport: {
      getList: "/api/LeadGenAccrualReport/getlist",
      downloadItem: (id: any) => `/api/LeadGenAccrualReport/download/${id}`,
      getPreviewList: (id: any) => `/api/LeadGenAccrualReport/getItemList/${id}`,
      getItemsDetail: (id: any) => `/api/LeadGenAccrualReport/item/get/${id}`,
      editItemsDetail: (id: any) => `/api/LeadGenAccrualReport/item/update/${id}`,
      submitItemDatas: (id: any) => `/api/LeadGenAccrualReport/submit/${id}`,
      getBillingSummary: (id: any) => `/api/LeadGenAccrualReport/getSummary/${id}`,
    }
  },
  GetDoc: {
    getHelpDoc: (productType: number) => `/api/Feedback/getHelpDoc/${productType}`,
    getTemplateZip: (params: any) => "/api/Feedback/getSampleZipByTemplateID",
    getTemplatePic: (params: any) => "/api/Feedback/getEffectImageByTemplateID",
  },
  CrossBorder: {
    getEndpoint: "/api/Authorization/endpoint",
    getGraphUserInfo: "/api/Authorization/authCallback",
    // refreshgetGraphUserInfo: "/api/Authorization/graphUserInfo",
    getMAPAccountList: "/api/MAPCustomerAccountSync/customerAndAccounts",
    asyncAccount: "/api/MAPCustomerAccountSync/syncAccount",
    getMAPAccount: (param: any) => `/api/Customer/${param.cid}/mapAccounts`,
    getMAPAccountStatus: (param: any) => `/api/Account/MAPAccountStatus?aid=${param.aid}`,
    getMAPAgreement: (param: any) => `/api/Authorization/agreement?email=${param.email}`,
    getOrderpausereason: (param: any) => `/api/Orders/pausereason/${param.orderId}`,
  },
  StoreAdsCPT: {
    StoreAdsMaterial: {
      getMaterialList: (param: any) => `/api/StoreAdsMaterial/${param.accountid}`,
      getMaterialDetail: (param: any) => `/api/StoreAdsMaterial/materialDetail/${param.materialld}`,
      createMaterial: "/api/StoreAdsMaterial/addMaterial",
      deleteMaterial: (param: any) => `/api/StoreAdsMaterial/deleteMaterial/${param.materialld}`,
      uploadMaterialImageFile: (aid: number) => `/api/AdCreativeForm/UploadStoreAdsImage/${aid}`,
      bindMaterial: "/api/StoreAdsMaterial/bindMaterial",
    }
  },
  StoreAds: {
    getPositionStock: "/api/StoreAdsPositionStock/positionStock",
    getOrderList: (accountId: number) => `/api/StoreAdsOrder/storeAdsOrderList/${accountId}`,
    getAppOptions: "/api/StoreAdsApp/queryApp",
    getCandidatePeriods: "/api/StoreAdPosition/candidatePeriods",
    getCouponOptions: "/api/StoreAdsCoupon/getCouponList",
    getCouponPrice: "/api/StoreAdsCoupon/calculateOrderPrice",
    createOrder: (data:any) => `/api/StoreAdsOrder/create/${data.accountId}`,
    getMaterialsByOrderList: (orderId: number) => `/api/StoreAdsMaterial/materialsByOrder/${orderId}`,
  },
};
